import Auth from '../modules/Authentication'
import { apiUrl } from '../variables/index'
import { handleErrors, handleResponse } from '../modules/Utils'

const headers = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
}
export default class Settings {
  constructor() {
    this.auth = new Auth()
  }

  get = (key) => {
    headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
    return fetch(`${apiUrl}settings/${key}`, { headers }).then(handleErrors).then(handleResponse)
  }
}
